// extracted by mini-css-extract-plugin
module.exports = {"container":"VastPermissionChange_container__2t9eb"};